/* eslint import/prefer-default-export: 0 */

import { PvqCitizenshipStatusOptions } from 'constants/enums/citizenshipOptions';

export const relationships = {
  pvq: {
    intro: {
      title: 'Relationships',
      body:
        'You will be asked questions about your personal relationships and be asked to provide details if necessary.',
    },
    tour: {
      para: 'Take a guided tour through the section',
    },
    review: {
      para: 'View all the sections associated with relationships at once',
    },
    comments: {
      branch: 'Optional Comment',
      optional: 'Optional Comment',
      summary: 'Optional Summary Comment'
    },
    section: {
      name: 'Relationships',
    },
    subsection: {
      intro: 'Introduction',
      status: 'Marital & relationship status',
      marital: 'Marital',
      cohabitants: 'Cohabitants',
      cohabitant: 'Cohabitants',
      relationshipStatus: 'Relationship Status',
      people: 'People who know you well',
      relatives: 'Relatives',
      review: 'Review',
    },
    destination: {
      intro: 'Relationships intro',
      review: 'Review Relationships',
      relatives: 'Relatives',
      marital: 'Marital status',
      people: 'People who know you well',
      cohabitant: 'Cohabitant',
      'status/marital': 'Marital status',
      'status/cohabitant': 'Cohabitant',
    },
    relatives: {
      requirements: {
        title: 'Requirements not met',
      },
      sectionTitle: {
        title: 'Relatives',
      },
      collection: {
        summary: {
          title: 'Summary of relatives',
          unknown: 'Click to provide details',
          item: 'Relative',
        },
        appendTitle:
          'Do you have another relative to report? (You must list all relatives even if they are deceased.)',
        append: 'Add another relative',
      },
      heading: {
        title:
          "If you have not had any contact with a relative select the box '[] No contact with family member' but you must still provide information about your relative to the best of your knowledge. If there is a safety reason for which you do not wish to provide your relative's information, contact the office that asked you to complete this form. However, you must still provide the information about your relative to the best of your knowledge. As noted in the instructions, the information you provide is protected under the Privacy Act and will be protected from unauthorized disclosure.",
        needmore: 'Since you answered yes we need more information',
        relation:
          'Who are your relatives? (Select one. There will be an opportunity to input multiple entries. List your mother even if you already provided her name in Part A of this form. List all relatives even if deceased.)',
        relativeCommentsTitle: 'Provide comments regarding this relative',
        pleaseExplain: 'Please Explain',
        addressExplanation: 'Provide an explanation regarding this current Address',
        courtAddressExplanation: 'Provide an explanation regarding this Court Address',
        name: "What is your relative's name?",
        birthdate: "What is your relative's date of birth?",
        birthplace:
          'Was your relative born in the U.S.? (The U.S. is defined as the 50 U.S. states, the District of Columbia, and the U.S. territories.)',
        citizenship: 'Provide country(ies) of citizenship for this relative. (Select all that apply.)',
        other: 'Please Explain',
        inContact: 'Have you ever been in contact with this relative?',
        alias: {
          branch: 'Has your relative ever used a different name?',
          title:
            'What other name have they used? For all listed relatives, you must include the name on their birth certificate.',
          describeName: 'Which of the following best describes this name?',
          whenUsed: 'When did they use this name?',
          other: 'Please explain',
          additional: 'Do they have another name you need to report?',
        },
        deceased: {
          branch: 'Is this person deceased?',
          address: 'Does this relative live in the U.S?',
          citizenshipStatus: 'What is their U.S. citizenship status?',
          domestic: 'What is their address? (List their last known address if you do not know their current address.)',
          foreign: 'Where do they live? Please provide physical address (not mailing address)',
        },
        us: {
          title: 'U.S. Citizenship Documentation',
          foreignDocument: 'What document do they have verifying they are a U.S. citizen born abroad?',
          naturalizedDocument: 'What document do they have verifying they are a naturalized U.S. citizen?',
          derivedDocument: 'What document do they have proving they are a derived U.S. citizen?',
          notUsResidence: 'What is their residence status?',
          notUsDocument: 'What document do they have proving they are authorized to be in the U.S.?',
          residence: 'What is their residence status?',
          otherTitle: 'What is the title of the form?',
          number:
            'What is the document number on the form? (This is not the form number. The document number may be listed as a registration number, serial number, or other number distinct to the person.)',
          serial:
            'What is the serial number on the document? (This is typically the number in the top right-hand corner of the document (it is often in red ink).)',
          name: 'Provide the name of the court that issued the Certificate of Naturalization',
          address: 'Provide the address of the court that issued the Certificate of Naturalization',
        },
        address: {
          title: 'Provide type of documentation he or she possesses to support U.S. residence:',
          number: 'Provide the document number',
          expiration: 'What is the expiration date of this document?',
          firstcontact: 'When was your first contact with this relative?',
          lastcontact: 'When was your last contact with this relative?',
          methods: 'What methods do you and this relative use to contact one another? (Select all that apply.)',
          frequency: 'How often are you in contact with this relative?',
        },
        employer: {
          name:
            'Who does your relative work for? (If your relative is unemployed, then provide the name of their most recent employer).',
          occupation: "If known, what is your relative's occupation?",
          address:
            "Is your relative's employer located in the U.S.?",
          affiliated:
            'Is this relative affiliated with a foreign (non-U.S.) government, military, security, defense industry, movement, or intelligence service?',
          anotherAffiliated:
            'Is this relative affiliated with another foreign (non-U.S.) government, military, security service, defense industry, movement, or intelligence service?',
          relationship:
            "What is your relative's relationship with this foreign (non-U.S.) government, military, security, defense industry, movement, or intelligence service?",
          idkLabel: "I Don't Know",
        },
        optionalComments: {
          title: 'Optional Comment',
        }
      },
      para: {
        opportunity: 'An opportunity will be provided to list multiple relatives for each type.',
        checkall: 'Check all that apply.',
        alias: 'Such as maiden, name by former marriage, former name, alias, or nickname.',
        abroad: 'Born abroad to U.S. Parents:',
        naturalized: 'Naturalized:',
        derived: 'Derived:',
        notcitizen: 'Not a U.S. Citizen:',
        or: 'or',
      },
      error: {
        documentExpiration: {
          before: {
            title: 'There is a problem with the date',
            message: "This date is before the relative's birthdate.",
          },
        },
        duplicateListItems: {
          title: 'Resolve errors above',
        }
      },
      label: {
        noContact: 'No Contact with Family Member',
        idk: "I Don't Know",
        nonum: 'No Number',
        idkNoNumber: "I Don't Know/No Number",
        notApplicable: 'Not Applicable',
        idkNeverWorked: "I Don't Know/Never Worked",
        neverWorked: 'Never Worked',
        relation: {
          parent: 'Parent',
          stepparent: 'Stepparent',
          fosterparent: 'Foster parent',
          child: ['Child (including adopted/foster)'],
          stepchild: 'Stepchild',
          sibling: 'Sibling',
          stepsibling: 'Step Sibling',
          halfsibling: 'Half Sibling',
          parentinlaw: 'Parent-in-law',
          guardian: 'Guardian',
        },
        citizenshipStatus: {
          usCitizen: 'A U.S. citizen by birth in the U.S. or a U.S. territory.',
          usForeign: 'A U.S. citizen by birth, born to U.S. parent(s), in a foreign country.',
          naturalized: 'A naturalized U.S. citizen.',
          derived: 'A derived U.S. citizen.',
          notUs: 'Not a U.S. citizen.',
          nationalByBirthInUs: 'A U.S. national by birth in the U.S. or a territory.',
          nationalByBirthOutsideUS: 'A U.S. national, born to U.S. parent(s), in a foreign country',
        },
        usForeign: {
          fs240: 'Form FS-240 (Consular Report of Birth Abroad)',
          ds1350: 'Form DS-1350 (Certificate of Report of Birth)',
          fs545: 'Form FS-545 (Certificate of Birth Abroad)',
          n560: 'Form N-560 or Form N-561 (Certificate of Citizenship)',
          other: 'Other',
        },
        naturalized: {
          certificate: 'Form N-550 or Form N-570 (Certificate of Naturalization)',
          permanentAlien:
            'Form I-551 (Permanent Resident Card/Resident Alien Card)',
          mriv: 'Form I-551 (Machine Readable Immigrant Visa (MRIV))',
          other: 'Other',
          alienNumber:
            'What is their U.S. alien registration number? \n• You can find their alien registration number on their Certificate of Naturalization (N-550 or N-570). It is a 7- to 9-digit number typically listed as the "USCIS Registration No.", "INS Registration No.", "CIS Registration No." It is not the "No." (short for number) in the top right hand corner often seen in red ink.',
          certNumber:
            'What is their Naturalization Certificate Number/ Naturalization Number? \n• This is the "No." (short for number) in the top right hand corner of their Certificate of Naturalization (N-550 or N-570). It is often in red ink.',
          courtName:
            'What is the name of the court that issued the Certificate of Naturalization (N-550 or N-570)? (Do not use acronyms or abbreviations.)',
          courtAddress: "What is the court's address?",
          alienNumberMriv:
            'What is their U.S. alien registration number? \n• You can find their alien registration number on their Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".',
        },
        derived: {
          certificate: 'Certificate of citizenship (N560 or N561)',
          permanentAlien:
            'Permanent Resident Card/Resident Alien Card (Form I-551)',
          mriv: 'Machine Readable Immigrant Visa (MRIV) (Form I-551)',
          other: 'Other',
          alienNumber:
            'What is their U.S. alien registration number? \n• You can find their alien registration number on their Certificate of Citizenship (Form N-560 or Form N-561). It is the 7- to 9-digit number typically listed as the "USCIS Registration No.", "CIS Registration No.", or "INS Registration No.".',
          certNumber:
            'What is their Citizenship Certificate Number/Citizenship Number? \n• This is the "No." (short for number) in the top right hand corner of their Certificate of Citizenship (Form N-560 or Form N-561). It is often in red ink.',
          alienNumberMriv:
            'What is their U.S. alien registration number? \n• You can find their alien registration number on their Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".',
        },
        document: {
          permanent: 'I-551 Permanent Resident',
          employment: 'I-766 Employment Authorization',
          mriv: 'Machine Readable Immigrant Visa (MRIV)',
          arrival: 'I-94 Arrival-Departure Record',
          visa: 'U.S. Visa (Red foil number)',
          f1: 'I-20 Certificate of Eligibility for Non-Immigrant-F1-Student',
          j1: 'DS-2019 Certificate of Eligibility of Exchange Visitor-J1-Status',
          other: 'Other',
          alienNumber:
            'What is their Alien Registration Number? \n• You can find their alien registration number on their Permanent Resident Card/Resident Alien Card (Form I-551) or on their Employment Authorization Card (Form I-766), as applicable. Their Alien Registration Number may be listed as the "A#", "A" number, "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV) Form I-551, it is the "Registration Number".',
          i94Number:
            'What is the document number? \n• For the Form I-94, list the 11-digit number labeled either "Admission Number", "Departure Number", "Admission Record (I-94) Number", or "I-94#". Or, they may have an "admission stamp" in their unexpired foreign passport. If this is the case, also list their passport number and the country that issued the passport.',
          visaNumber:
            'What is the document number? \n• For the U.S. Visa Card (nonimmigrant visa) -- the visa number, also called a visa foil number, is a red number that is generally printed on the bottom right corner of newer visa documents. In most cases, the U.S. visa number contains eight numeric characters. In some cases, the number contains one letter followed by seven numeric characters.',
          i20Number:
            'What is the document number? \n• For the Form I-20, list the "SEVIS ID" number near the top left or top right corner of the document (depending on the document version). All SEVIS ID numbers start with the letter N. If they also have an "Admission Number" on their Form I-20 document, list this number as well (this is their Form I-94 number).',
          ds2019Number:
            'What is the document number? \n• For the Form DS-2019, list the number on the top right hand side of the page in the box above the barcode. This is the SEVIS number. All SEVIS ID numbers start with the letter N.',
        },
        residency: {
          permanent: 'Permanent Resident',
          asylee: 'Asylee/Refugee',
          nonimmigrant: 'Nonimmigrant',
          tps: 'Temporary Protected Status (TPS)',
          daca: 'Deferred Action for Childhood Arrivals (DACA)',
          other: 'Other',
        },
        methods: {
          inperson: 'In person',
          telephone: 'Telephone',
          electronic: 'Electronic means (for example, email, texting, chat rooms)',
          written: 'Written correspondence',
          other: 'Other',
          none: 'None',
        },
        frequency: {
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly',
          quarterly: 'Quarterly',
          annually: 'Annually',
          other: 'Other',
        },
        association: {
          military: 'Military or Armed Forces',
          security: 'Security Service',
          intelligence: 'Intelligence Service',
          government: 'Other Government Agency',
          defense: 'Defense Industry',
          foreign: 'Foreign Movement',
          not: 'Not Associated',
          other: 'Other',
          explain: 'Please Explain',
        },
        maiden: {
          same: 'Same as listed',
          diff: 'Different name',
        },
        estimated: 'Estimated',
        birthplace:
          'Was this person born in the United States of America?',
      },
      help: {
        relation: {
          title: 'Need help selecting relatives?',
          message: 'Select the relatives relationship to you',
          note: '',
        },
        birthdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthplace: {
          title: 'Need help with the place of birth?',
          message: 'Provide the place of birth',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
        maiden: {
          title: 'Need help with the maiden name?',
          message: 'Provide the maiden name of your mother',
          note: '',
        },
        deceased: {
          title: 'Need help with the deceased?',
          message: 'If your relative is no longer living please answer "Yes"',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        abroad: {
          title: 'Need help if the relative was born abroad?',
          message: 'Select the appropriate type of documentation.',
          note: '',
        },
        naturalized: {
          title: 'Need help if the relative was naturalized?',
          message: 'Select the appropriate type of documentation',
          note: '',
        },
        derived: {
          title: 'Need help if the relative is a derived citizen?',
          message: 'Select the appropriate type of documentation',
          note: '',
        },
        documentnumber: {
          title: 'Need help with the document number?',
          message: 'Provide the document number for the citizenship',
          note: '',
        },
        documentexpiration: {
          title: 'Need help with the date of expiration?',
          message: 'Provide the approximate date of expiration',
          note: '',
        },
        courtname: {
          title: 'Need help with the court name?',
          message: 'Provide the court name that issued the Certificate of Naturalization',
          note: '',
        },
        courtaddress: {
          title: 'Need help with the court address?',
          message: 'Provide the address of the court that issued the Certificate of Naturalization',
          note: '',
        },
        document: {
          title: 'Need help if the relative has documentation to support U.S. residence?',
          message:
            'If the relative resides in the U.S. but is not a citizen provide the documentation',
          note: '',
        },
        documentnumberexplanation: {
          title: 'Need help with the document number explanation?',
          message: 'Provide an explanation for document number',
          note: '',
        },
        residencedocumentnumber: {
          title: 'Need help with the residence document number?',
          message: 'Provide the residence document number',
          note: '',
        },
        expiration: {
          title: 'Need help with the expiration date?',
          message: 'Provide the expiration date',
          note: '',
        },
        firstcontact: {
          title: 'Need help with the date of first contact?',
          message: 'Provide the approximate date of first contact',
          note: '',
        },
        lastcontact: {
          title: 'Need help with the date of last contact?',
          message: 'Provide the approximate date of last contact',
          note: '',
        },
        methods: {
          title: 'Need help with the methods of correspondence with the relative?',
          message: 'Select all types of correspondence used with the relative',
          note: '',
        },
        frequency: {
          title: 'Need help with the frequency of correspondence?',
          message: 'Provide the best response to how often you correspond with the relative',
          note: '',
        },
        employer: {
          title: "Need help with the relative's employer name?",
          message: 'Provide the employer name or select "I don\'t know" if unknown',
          note: '',
        },
        employeraddress: {
          title: "Need help with the relative's employer's address?",
          message: 'Provide the employer address or select "I don\'t know" if unknown',
          note: '',
        },
        affiliation: {
          title: 'Need help if the relative has any foreign affiliations?',
          message:
            'If the relative is affiliated with a foreign government, military, security, defense industry, foreign movement, or intelligence service answer "Yes"',
          note: '',
        },
        employerrelationship: {
          title: "Need help with the relative's relationships to foreign affiliates?",
          message:
            'Describe the affiliation with the foreign government, military, security, defense industry, foreign movement, or intelligence service answer "Yes"',
          note: '',
        },
        aliasdates: {
          title: 'Need help with the date range the other name was used?',
          message: 'Provide the approximate date range the name was used',
          note: '',
        },
      },
      prefill: {
        name: {
          first: 'NBISDNK',
          middle: 'NBISDNK',
          last: 'NBISDNK',
        },
        birthdate: {
          day: '1',
          month: '1',
          year: '1900',
        },
        birthplace: {
          city: 'NBISDNK',
          state: 'DC',
          country: {
            value: 'United States',
          },
        },
        citizenship: {
          name: 'Citizenship',
          value: 'United States',
        },
        deceased: {
          name: 'is_deceased',
          value: 'Yes',
        },
        aliases: {
          name: 'has_alias',
          value: 'No',
        },
        maidenSameAsListed: {
          name: 'maiden_diff',
          value: 'Yes',
        },
        confirmation:
          'Are you sure you would like to change your answer? This will remove any data currently entered.',
      },
    },
    marital: {
      sectionTitle: {
        title: 'Marital',
      },
      sectionTitleAB: {
        title: 'Relationship Status',
      },
      para: {
        intro: 'This section asks for information regarding your current relationship status. We also ask for general information regarding former legally-recognized spouses or partners, as applicable. For purposes of this form, the term "committed, spouse-like relationship" is defined as a relationship between two people who are not in a legally-recognized marriage, union, or domestic partnership, present themselves as a couple, and live together continuously.'
      },
      heading: {
        title:
          'Provide your current marital/relationship status with regard to civil marriage, legally recognized civil union, or legally recognized domestic partnership.',
      },
      label: {
        status: {
          never:
            'Never entered into a civil marriage, legally recognized civil union, or legally recognized domestic partnership',
          married:
            'Currently in a civil marriage, legally recognized civil union, or legally recognized domestic partnership',
          separated: 'Separated',
          annulled: 'Annulled',
          divorced: 'Divorced/dissolved',
          widowed: 'Widowed',
        },
      },
      errors: {
        documentExpiration: {
          tooEarly: {
            title: 'Document Expiration Date',
            message: 'Document expiration is too early',
          },
        },
      },
      confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
    },
    civilUnion: {
      heading: {
        name: "Provide this person's full name",
        birthdate: "Provide this person's date of birth",
        birthplace: 'Were they born in the U.S.?',
        foreignBornDocument:
          'If the person is foreign born, provide one type of documentation that he or she possesses and the document number.',
        ssn: 'What is their U.S. Social Security Number?',
        othernames: 'Have they ever used a different name?',
        appendOthernames: 'Do they have another name you need to report?',
        citizenship: 'Provide country(ies) of citizenship',
        address: "Provide this person's current address, if different than your current address",
        addressWithoutCurrent: "Provide this person's current address",
        telephone: 'What is their phone number?',
        email: 'What is their email address?',
        separated: 'Are you separated?',
        dateSeparated: 'When did you legally separate?',
        enteredCivilUnion: 'When did you enter this civil marriage, civil union, domestic partnership, or common law marriage?',
        locationCivilUnion: 'Did you enter this civil marriage, civil union, domestic partnership, or common law marriage while in the U.S.?',
        locationFollowupCivilUnion: 'Where did you enter this civil marriage, civil union, domestic partnership, or common law marriage?',
        locationSeparated: 'If legally separated, provide the location of the record',
        divorced: 'Do you have a former legally-recognized spouse or partner that you have not reported on this form?',
        addressSeparated: 'Are the legal documents for your separation recorded in the U.S.?',
        sameLocation: 'Do they live with you at the same address?',
        govName: 'What is the name of the government office where your separation documents are recorded? (Do not use acronyms or abbreviations.)',
        where: 'Where are they recorded?',
      },
      notApplicable: {
        or: 'or',
        label: 'Not applicable',
        idk: "I Don't Know",
      },
      useCurrentAddress: {
        or: 'or',
        label: 'Use my current address',
      },
      useApplicantPhoneNotApplicable: {
        or: 'or',
        label: 'Use my telephone number',
        idk: "I Don't Know",
      },
      deceasedAddressNotApplicable: {
        or: 'or',
        label: "I don't know",
      },
      para: {
        heading: 'Complete the following about your partner',
        name: 'What is the name of your spouse or partner?',
        birthdate: 'What is their date of birth?',
        othernames:
          'Such as maiden name, names by other marriages, civil marriages, legally recognized civil unions, or legally recognized domestic partnerships, nicknames, etc., and provide dates used for each name.',
      },
      label: {
        birthplace: 'The U.S. is defined as the 50 U.S. states, the District of Columbia, and the U.S. territories.',
        location: 'Was this location in the United States?',
        addressSeparated: 'Was this location in the United States?',
      },
      divorce: {
        heading: {
          name: 'What is the name of the person you were in a civil marriage, civil union, domestic partnership, or common law marriage with?',
          address: 'Provide the location',
          birthdate: "Provide this person's date of birth",
          citizenship: 'Provide country(ies) of citizenship (Select all that apply.)',
          telephone: 'What is their phone number?',
          email: 'What is their email address? (You may list more than one.)',
          birthplace: 'Were they born in the U.S.?',
          divorceLocation: 'Provide where the record of divorce/dissolution or annulment is located',
          recognized:
            'Provide the date your civil marriage, civil union, or domestic partnership was legally recognized',
          deceased: 'Is this person deceased?',
          deceasedAddress:
            'Provide last known address of the person from whom you are divorced/dissolved or annulled',
          deceasedDate: 'When did they die?',
          status: 'Provide status',
          dateDivorced: 'What is the date of your divorce, dissolution, or annulment?',
          divorceAddress: "Is this person's last known address in the U.S?",
          nameWidow: "What is your deceased spouse or partner's name?",
          dateWidow: 'When did they die?',
        },
        label: {
          divorced: 'Divorced/Dissolved',
          widowed: 'Widowed',
          annulled: 'Annulled',
          birthplace: 'Was this person born in the United States of America?',
        },
        para: {
          intro:
            'Provide information about any person from whom you are divorced/dissolved or annulled',
        },
        paraAB: {
          intro:
            'Complete the following about the person with whom you are in a civil marriage, legally recognized civil union, legally recognized domestic partnership, committed spouse-like relationship, or the person from whom you are currently legally separated.',
        },
        deceased: {
          label: {
            yes: 'Yes',
            no: 'No',
            dontKnow: "I don't know",
          },
        },
        collection: {
          description: 'Summary of former partner',
          appendTitle:
            'Do you have a former legally-recognized spouse or partner that you have not reported on this form?',
          appendLabel: 'Add another person',
          itemType: 'Person',
        },
        help: {
          birthdate: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          birthplace: {
            title: 'Need help with the birth place?',
            message: 'Provide the place of birth',
            note: '',
          },
          recognized: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          separated: {
            title: 'Need help with separated?',
            message: 'Mark whether you are separated',
            note: '',
          },
          divorced: {
            title: 'Need help with this question?',
            message: 'Mark whether you are currently divorced',
            note: '',
          },
          email: {
            title: 'Need help with providing email?',
            message: 'Enter the email of the person',
            note: '',
          },
          telephone: {
            title: 'Need help with providing a telephone number?',
            message: 'Enter the telephone number of the person',
            note: '',
          },
          address: {
            title: 'Acronyms:',
            message: 'APO - Army Post Office, FPO - Fleet Post Office.',
            note: '',
          },
          dateDivorced: {
            title: 'Estimate the date if unsure',
            message:
              'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
        },
      },
      othernames: {
        heading: {
          name: 'What other name have they used?',
          describe: 'Which of the following best describes this name?',
          used: 'When did they use this name?',
        },
      },
      help: {
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        addressSeparated: {
          title: 'Need help with the marital address?',
          message: 'Provide the location of the record if legally separated',
          note: '',
        },
        telephone: {
          title: 'Need help with the telephone number?',
          message: 'Provide the telephone number',
          note: '',
        },
        dateSeparated: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthplace: {
          title: 'Need help with the birth place?',
          message: 'Provide the place of birth',
          note: '',
        },
        foreignBornDocument: {
          title: 'Find the documentation',
          message: 'The document type and number will be on the documentation.',
          note: '',
        },
        othernames: {
          title: 'Need help with other names used?',
          message:
            'Such as maiden name, names by other marriages, civil marriages, legally recognized civil unions, or legally recognized domestic partnerships, nicknames, etc., and provide dates used for each name.',
          note: '',
        },
        separated: {
          title: 'Need help with separated?',
          message: 'Mark whether you are separated',
          note: '',
        },
        divorced: {
          title: 'Need help with this question?',
          message: 'Mark whether you are currently divorced',
          note: '',
        },
        email: {
          title: 'Need help with providing email?',
          message: 'Enter the email of the person',
          note: '',
        },
        hasCohabitant: {
          title: 'Need help with this question?',
          message:
            'Do you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience?',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
      },
    },
    cohabitant: {
      sectionTitle: {
        title: 'Cohabitants',
      },
      heading: {
        hasCohabitant:
          'Do you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience?',
        name: "Provide your cohabitant's full name",
        address: 'Provide location',
        birthdate: "Provide your cohabitant's birthdate",
        telephone: "Provide your cohabitant's telephone number",
        birthplace: "Provide your cohabitant's the place of birth",
        foreignBornDocument:
          'If the person is foreign born, provide one type of documentation that he or she possesses and the document number',
        ssn: 'Provide your cohabitant’s U.S. Social Security Number',
        othernames: 'Has your cohabitant used another name?',
        appendOthernames: 'Has your cohabitant used any other names?',
        citizenship: "Provide your cohabitant's country(ies) of citizenship",
        cohabitationBegan: 'Provide date cohabitation residing with person began',
      },
      suggestion: {
        title: "Looks like you've entered this person before",
        paragraph:
          'This name matches a spouse entered under the marital section.\n\nEnter only people who you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience (e.g. a roommate).',
        dismissLabel: 'This is not my spouse',
        label: 'Spouse match',
        useLabel: 'This is my spouse',
      },
      othernames: {
        heading: {
          name: 'Provide full name',
          maiden: "Is this your cohabitant's maiden name?",
          used: 'Provide dates name was used',
        },
      },
      label: {
        divorced: 'Divorced/Dissolved',
        widowed: 'Widowed',
        annulled: 'Annulled',
        birthplace: 'Was this person born in the United States of America?',
      },
      collection: {
        description: 'Summary of cohabitants',
        appendTitle: 'Do you have an additional cohabitant to report?',
        appendLabel: 'Add another cohabitant',
        itemType: 'Cohabitant',
      },
      help: {
        birthdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthplace: {
          title: 'Need help with the birth place?',
          message: 'Provide the place of birth',
          note: '',
        },
        recognized: {
          title:
            'Need help with providing date your civil marriage, civil union, or domestic partnership was legally recognized?',
          message:
            'Provide the date your civil marriage, civil union, or domestic partnership was legally recognized',
          note: '',
        },
        separated: {
          title: 'Need help with separated?',
          message: 'Mark whether you are separated',
          note: '',
        },
        divorced: {
          title: 'Need help with this question?',
          message: 'Mark whether you are currently divorced',
          note: '',
        },
        email: {
          title: 'Need help with providing email?',
          message: 'Enter the email of the person',
          note: '',
        },
        telephone: {
          title: 'Need help with providing a telephone number?',
          message: 'Enter the telephone number of the person',
          note: '',
        },
        address: {
          title: 'Need help with providing address?',
          message:
            'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        dateDivorced: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        foreignBornDocument: {
          title: 'Need help with selecting the appropriate documentation?',
          message:
            'If the person is foreign born, provide one type of documentation that he or she possesses and the document number',
          note: '',
        },
        ssn: {
          title: 'Need help with Social Security Number?',
          message: 'Provide the Social Security Number of the person',
          note: '',
        },
        cohabitationBegan: {
          title: 'When did you start living with this person?',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        hasCohabitant: {
          title: 'Cohabitation',
          message:
            'If you live with an individual for reasons of convenience (e.g. a roommate), please select no below. If you share any bonds of affection, obligation, or other commitment with an individual you cohabitate with, please select “yes” below.',
          note: '',
        },
        citizenship: {
          title: 'List all citizenships this person has',
          message:
            'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
          note: '',
        },
      },
    },
    people: {
      sectionTitle: {
        title: 'Section 10: People Who Know You Well',
      },
      label: {
        unit: 'People added',
      },
      summaryProgress: {
        title: 'People who know you well {{years}} year coverage',
        unit: 'Years covered',
        svgAlt: 'People who know you well {{years}} year coverage',
      },
      para: {
        intro:
          'This section asks for information regarding people who know you well (such as associates, friends, or peers) and are aware of your activities outside of your neighborhood, school, or workplace. Examples of outside activities include free time, recreational, or social. Please provide three people who you have known collectively for the past five years or longer and who preferably live in the U.S. Do not list your spouse; partner from a civil union, domestic partnership, or common law marriage; person you are in a committed, spouse-like relationship with; relatives; or anyone you\'ve listed previously on this questionnaire.\n\n List an associate, friend, peer, or other person who knows you well and is aware of your activities outside of your neighborhood, school, or workplace.',
      },
      error: {
        duplicateListItems: {
          title: 'Resolve errors above',
        },
        duplicatePeopleWhoKnowYouError: {
          title: 'Duplicate People Who Know You',
          message: 'There is a name and address which match a person listed in the People Who Know You Well section.  Name and Address cannot match a person listed anywhere else in the security form.  Please update the People Who Know You Well section.'
        },
        duplicatePeopleWhoKnowYouWarning: {
          title: 'Duplicate People Who Know You',
          message: 'There are names which match a person listed in the People Who Know You Well section. Ensure you do not list the same person in the People Who Know You Well section that you have also listed here:'
        },
      },
      person: {
        heading: {
          knownDates: 'Provide dates known',
          fromDate: 'When did you meet this individual?',
          toDate: 'When was your last contact with this individual?',
          contactFrequency: 'How often do you have contact with this individual?',
          contactFrequencyOther: 'Please Explain',
          name: 'What is their name?',
          rank: "Provide this person's rank/title",
          relationship: 'What is your current relationship with this individual?',
          telephone: 'What is their phone number?',
          address: 'Do they currently live or work in the U.S.?',
          domesticAddress: 'What is their address?',
          foreignAddress: 'Where are they located?',
        },
        emails: {
          title: 'Email Address',
          branch: {
            title: 'What is this person\'s email address? (You may list more than one.)',
          },
          summary: {
            title: 'Summary of emails',
          },
          append: 'Add another email',
        },
        label: {
          address: 'This address is',
          or: 'or',
          idk: "I don't know",
          notApplicable: 'Not applicable',
          relationship: {
            title: 'Check all that apply.',
            neighbor: 'Neighbor',
            friend: 'Friend',
            workAssociate: 'Work Associate',
            schoolmate: 'Schoolmate',
            other: 'Other',
            explanation: 'Provide explanation',
          },
        },
        gap: {
          title: 'Coverage gap',
          para:
            'There is a gap in your {{years}} year period. The entire {{years}} years should be covered with no gaps.',
          button: 'Add another person',
        },
        personsGap: {
          title: 'Coverage gap',
          message: 'List at least 3 people who know you well.',
          note: '',
        },
        help: {
          knownDates: {
            title: 'Tell us the entire time you have known this person',
            message:
              'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
            note: '',
          },
          rank: {
            title: 'Need help with the rank/title?',
            message: 'Provide the rank/title of the person who knows you well',
            note: '',
          },
          relationship: {
            title: 'Need help with the relationship?',
            message: 'Provide relationship to you for the person who knows you well',
            note: '',
          },
          mobileTelephone: {
            title: 'Need help with the mobile telephone?',
            message: 'Provide a mobile number for the person who knows you well',
            note: '',
          },
          otherTelephone: {
            title: 'Need help with the other telephone?',
            message: 'Provide another number for the person who knows you well',
            note: '',
          },
          email: {
            title: 'Need help with the email?',
            message: 'Provide the email for the person who knows you well',
            note: '',
          },
          address: {
            title: 'Details:',
            message: 'Military APO/FPO addresses are not permitted.',
            note: '',
          },
        },
        collection: {
          summary: {
            unknown: "Provide the person's information below",
          },
          description: 'Summary of people who know you',
          appendLabel: 'Add another person',
          appendTitle: 'Do you have another individual who knows you well to report? (You must list three people who you have known collectively for the past five years.)',
          itemType: 'Person',
        },
      },
    },
  },
  intro: {
    title: 'Relationships',
    body:
      'You will be asked questions about your personal relationships and be asked to provide details if necessary.',
  },
  tour: {
    para: 'Take a guided tour through the section',
  },
  review: {
    para: 'View all the sections associated with relationships at once',
  },
  comments: {
    branch: 'Optional Comment',
    optional: 'Optional Comment',
    summary: 'Optional Summary Comment'
  },
  section: {
    name: 'Relationships',
  },
  subsection: {
    intro: 'Introduction',
    status: 'Marital & relationship status',
    marital: 'Marital',
    cohabitants: 'Cohabitants',
    cohabitant: 'Cohabitants',
    people: 'People who know you well',
    relatives: 'Relatives',
    review: 'Review',
  },
  destination: {
    intro: 'Relationships intro',
    review: 'Review Relationships',
    relatives: 'Relatives',
    marital: 'Marital status',
    people: 'People who know you well',
    cohabitant: 'Cohabitant',
    'status/marital': 'Marital status',
    'status/cohabitant': 'Cohabitant',
  },
  relatives: {
    requirements: {
      title: 'Requirements not met',
    },
    sectionTitle: {
      title: 'Relatives',
    },
    collection: {
      summary: {
        title: 'Summary of relatives',
        unknown: 'Click to provide details',
        item: 'Relative',
      },
      appendTitle: 'Do you have an additional relative to enter?',
      append: 'Add another relative',
    },
    heading: {
      title: 'Add each relative applicable to you, regardless if they are living or deceased.',
      needmore: 'Since you answered yes we need more information',
      relation: 'Provide relative type',
      relativeCommentsTitle: 'Provide comments regarding this relative',
      documentnumberexplanation: 'Provide an explanation regarding this Document Number',
      addressExplanation: 'Provide an explanation regarding this current Address',
      courtAddressExplanation: 'Provide an explanation regarding this Court Address',
      firstContactExplanation: 'Provide an explanation regarding this First Contact',
      name: "Provide your relative's full name",
      birthdate: "Provide your relative's date of birth",
      birthplace: "Provide your relative's place of birth",
      citizenship: "Provide your relative's country(ies) of citizenship",
      maiden: "Provide your mother's maiden name",
      alias: {
        branch: 'Has this relative used any additional names?',
        title: 'Provide other names used and the period of time that your relative used them.',
        maiden: 'Was this their maiden name?',
        reason: 'Provide the reason(s) why the name changed.',
        additional: 'Has this relative used any additional names?',
      },
      deceased: {
        branch: 'Is your relative deceased?',
        address: "Provide your relative's current address",
      },
      us: {
        title: 'U.S. Citizenship Documentation',
        documentation: 'Provide one type of citizenship documentation and document number below:',
        number: 'Provide the document number',
        name: 'Provide the name of the court that issued the Certificate of Naturalization',
        address: 'Provide the address of the court that issued the Certificate of Naturalization',
      },
      address: {
        title: 'Provide type of documentation he or she possesses to support U.S. residence:',
        number: 'Provide the document number',
        expiration: 'Provide document expiration date',
        firstcontact: 'Provide approximate date of first contact',
        lastcontact: 'Provide approximate date of last contact',
        methods: 'Provide methods of contact',
        frequency: 'Provide approximate frequency of contact',
      },
      employer: {
        name:
          'Provide name of current employer, or provide the name of their most recent employer if not currently employed (if known)',
        address:
          'Provide the address of current employer, or provide the address of their most recent employer if not currently employed',
        affiliated:
          'Is this relative affiliated with a foreign government, military, security, defense industry, foreign movement, or intelligence service?',
        relationship:
          "Describe the relative's relationship with the foreign government, military, security, defense industry, foreign movement, or intelligence service.",
      },
      optionalComments: {
        title: 'Optional Comment',
      }
    },
    para: {
      opportunity: 'An opportunity will be provided to list multiple relatives for each type.',
      checkall: 'Check all that apply.',
      alias: 'Such as maiden, name by former marriage, former name, alias, or nickname.',
      abroad: 'Born abroad to U.S. Parents:',
      naturalized: 'Naturalized:',
      derived: 'Derived:',
      notcitizen: 'Not a U.S. Citizen:',
      or: 'or',
    },
    error: {
      documentExpiration: {
        before: {
          title: 'There is a problem with the date',
          message: "This date is before the relative's birthdate.",
        },
      },
      duplicateListItems: {
        title: 'Resolve errors above',
      }
    },
    label: {
      idk: "I don't know",
      idkRelative: "I don't know the requested information",
      knownRelative: 'Do you know this relative?',
      relation: {
        mother: 'Mother',
        father: 'Father',
        stepmother: 'Stepmother',
        stepfather: 'Stepfather',
        fosterparent: 'Foster parent',
        child: ['Child (including adopted/foster)'],
        stepchild: 'Stepchild',
        brother: 'Brother',
        sister: 'Sister',
        stepbrother: 'Stepbrother',
        stepsister: 'Stepsister',
        halfbrother: 'Half-brother',
        halfsister: 'Half-sister',
        fatherinlaw: 'Father-in-law',
        motherinlaw: 'Mother-in-law',
        guardian: 'Guardian',
      },
      abroad: {
        fs: 'FS 240 or 545',
        ds: 'DS 1350',
      },
      naturalized: {
        alien:
          'Alien Registration (on Certification of Naturalization - utilize USCIS, CIS, or INS registration number)',
        permanent: 'Permanent resident card (I-551)',
        certificate: 'Certificate of naturalization (N550 or N570)',
      },
      derived: {
        alien:
          'Alien Registration (on Certification of Naturalization - utilize USCIS, CIS, or INS registration number)',
        permanent: 'Permanent resident card (I-551)',
        certificate: 'Certificate of citizenship (N560 or N561)',
        other: 'Other (provide explanation)',
      },
      methods: {
        inperson: 'In person',
        telephone: 'Telephone',
        electronic: 'Electronic (such as email, texting, chat rooms, etc.)',
        written: 'Written correspondence',
        other: 'Other (provide explanation)',
      },
      frequency: {
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        annually: 'Annually',
        other: 'Other (provide explanation)',
      },
      document: {
        permanent: 'I-551 Permanent Resident',
        employment: 'I-766 Employment Authorization',
        arrival: 'I-94 Arrival-Departure Record',
        visa: 'U.S. Visa (red foil number)',
        f1: 'I-20 Certificate of Eligibility (non-immigrant F1 student)',
        j1: 'DS-2019 Certificate of Eligibility (exchange visitor J1 status)',
        other: 'Other (provide explanation)',
      },
      maiden: {
        same: 'Same as listed',
        diff: 'Different name',
      },
      estimated: 'Estimated',
      birthplace: 'Was this person born in the United States of America?',
    },
    help: {
      relation: {
        title: 'Need help selecting relatives?',
        message: 'Select the relatives relationship to you',
        note: '',
      },
      birthdate: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      birthplace: {
        title: 'Need help with the place of birth?',
        message: 'Provide the place of birth',
        note: '',
      },
      citizenship: {
        title: 'List all citizenships this person has',
        message:
          'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
        note: '',
      },
      maiden: {
        title: 'Need help with the maiden name?',
        message: 'Provide the maiden name of your mother',
        note: '',
      },
      deceased: {
        title: 'Need help with the deceased?',
        message: 'If your relative is no longer living please answer "Yes"',
        note: '',
      },
      address: {
        title: 'Acronyms:',
        message: 'APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
      abroad: {
        title: 'Need help if the relative was born abroad?',
        message: 'Select the appropriate type of documentation.',
        note: '',
      },
      naturalized: {
        title: 'Need help if the relative was naturalized?',
        message: 'Select the appropriate type of documentation',
        note: '',
      },
      derived: {
        title: 'Need help if the relative is a derived citizen?',
        message: 'Select the appropriate type of documentation',
        note: '',
      },
      documentnumber: {
        title: 'Need help with the document number?',
        message: 'Provide the document number for the citizenship',
        note: '',
      },
      documentexpiration: {
        title: 'Need help with the date of expiration?',
        message: 'Provide the approximate date of expiration',
        note: '',
      },
      courtname: {
        title: 'Need help with the court name?',
        message: 'Provide the court name that issued the Certificate of Naturalization',
        note: '',
      },
      courtaddress: {
        title: 'Need help with the court address?',
        message: 'Provide the address of the court that issued the Certificate of Naturalization',
        note: '',
      },
      document: {
        title: 'Need help if the relative has documentation to support U.S. residence?',
        message:
          'If the relative resides in the U.S. but is not a citizen provide the documentation',
        note: '',
      },
      documentnumberexplanation: {
        title: 'Need help with the document number explanation?',
        message: 'Provide an explanation for document number',
        note: '',
      },
      residencedocumentnumber: {
        title: 'Need help with the residence document number?',
        message: 'Provide the residence document number',
        note: '',
      },
      expiration: {
        title: 'Need help with the expiration date?',
        message: 'Provide the expiration date',
        note: '',
      },
      firstcontact: {
        title: 'Need help with the date of first contact?',
        message: 'Provide the approximate date of first contact',
        note: '',
      },
      lastcontact: {
        title: 'Need help with the date of last contact?',
        message: 'Provide the approximate date of last contact',
        note: '',
      },
      methods: {
        title: 'Need help with the methods of correspondence with the relative?',
        message: 'Select all types of correspondence used with the relative',
        note: '',
      },
      frequency: {
        title: 'Need help with the frequency of correspondence?',
        message: 'Provide the best response to how often you correspond with the relative',
        note: '',
      },
      employer: {
        title: "Need help with the relative's employer name?",
        message: 'Provide the employer name or select "I don\'t know" if unknown',
        note: '',
      },
      employeraddress: {
        title: "Need help with the relative's employer's address?",
        message: 'Provide the employer address or select "I don\'t know" if unknown',
        note: '',
      },
      affiliation: {
        title: 'Need help if the relative has any foreign affiliations?',
        message:
          'If the relative is affiliated with a foreign government, military, security, defense industry, foreign movement, or intelligence service answer "Yes"',
        note: '',
      },
      employerrelationship: {
        title: "Need help with the relative's relationships to foreign affiliates?",
        message:
          'Describe the affiliation with the foreign government, military, security, defense industry, foreign movement, or intelligence service answer "Yes"',
        note: '',
      },
      aliasdates: {
        title: 'Need help with the date range the other name was used?',
        message: 'Provide the approximate date range the name was used',
        note: '',
      },
    },
    prefill: {
      name: {
        first: 'NBISDNK',
        middle: 'NBISDNK',
        last: 'NBISDNK',
      },
      birthdate: {
        day: '1',
        month: '1',
        year: '1900',
      },
      birthplace: {
        city: 'NBISDNK',
        state: 'DC',
        country: {
          value: 'United States',
        },
      },
      citizenship: {
        name: 'Citizenship',
        value: 'United States',
      },
      deceased: {
        name: 'is_deceased',
        value: 'Yes',
      },
      aliases: {
        name: 'has_alias',
        value: 'No',
      },
      maidenSameAsListed: {
        name: 'maiden_diff',
        value: 'Yes',
      },
      confirmation:
        'Are you sure you would like to change your answer? This will remove any data currently entered.',
    },
  },
  marital: {
    sectionTitle: {
      title: 'Marital',
    },
    heading: {
      title:
        'Provide your current marital/relationship status with regard to civil marriage, legally recognized civil union, or legally recognized domestic partnership.',
    },
    label: {
      status: {
        never:
          'Never entered into a civil marriage, legally recognized civil union, or legally recognized domestic partnership',
        married:
          'Currently in a civil marriage, legally recognized civil union, or legally recognized domestic partnership',
        separated: 'Separated',
        annulled: 'Annulled',
        divorced: 'Divorced/dissolved',
        widowed: 'Widowed',
      },
    },
    errors: {
      documentExpiration: {
        tooEarly: {
          title: 'Document Expiration Date',
          message: 'Document expiration is too early',
        },
      },
    },
    confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
  },
  civilUnion: {
    heading: {
      name: "Provide this person's full name",
      birthdate: "Provide this person's date of birth",
      birthplace: "Provide this person's place of birth",
      foreignBornDocument:
        'If the person is foreign born, provide one type of documentation that he or she possesses and the document number.',
      ssn: "Provide this person's U.S. Social Security Number",
      othernames: 'Has this person used another name?',
      appendOthernames: 'Has this person used any other names?',
      citizenship: "Provide this person's country(ies) of citizenship",
      location: 'Provide the location',
      address: "Provide this person's current address, if different than your current address",
      addressWithoutCurrent: "Provide this person's current address",
      telephone: "Provide this person's telephone number",
      email: "Provide this person's email address",
      separated: 'Are you separated?',
      dateSeparated: 'Provide date of separation',
      enteredCivilUnion:
        'Provide date when you entered into your civil marriage, civil union, or domestic partnership.',
      locationSeparated: 'If legally separated, provide the location of the record',
      divorced:
        'Do you have a person from whom you are divorced/dissolved, annulled, or widowed to report?',
      addressSeparated: 'If legally separated, provide the location of the record.',
    },
    notApplicable: {
      or: 'or',
      label: 'Not applicable',
    },
    useCurrentAddress: {
      or: 'or',
      label: 'Use my current address',
    },
    useApplicantPhoneNotApplicable: {
      or: 'or',
      label: 'Use my telephone number',
    },
    deceasedAddressNotApplicable: {
      or: 'or',
      label: "I don't know",
    },
    para: {
      never:
        'Complete the following about the person with whom you are in a civil marriage, legally recognized civil union, or legally recognized domestic partnership, or the person from whom you are currently separated.',
      othernames:
        'Such as maiden name, names by other marriages, civil marriages, legally recognized civil unions, or legally recognized domestic partnerships, nicknames, etc., and provide dates used for each name.',
    },
    label: {
      birthplace: 'Was this person born in the United States of America?',
      location: 'Was this location in the United States?',
      addressSeparated: 'Was this location in the United States?',
    },
    divorce: {
      heading: {
        name: "Provide this person's full name",
        address: 'Provide the location',
        birthdate: "Provide this person's date of birth",
        citizenship: 'Provide the country(ies) of citizenship',
        telephone: "Provide this person's telephone number",
        birthplace: "Provide this person's place of birth",
        dateDivorced: 'Provide the date divorced/dissolved, annulled or widowed',
        divorceLocation: 'Provide where the record of divorce/dissolution or annulment is located',
        recognized:
          'Provide the date your civil marriage, civil union, or domestic partnership was legally recognized',
        deceased: 'Is this person deceased?',
        deceasedAddress:
          'Provide last known address of the person from whom you are divorced/dissolved or annulled',
        status: 'Provide status',
      },
      label: {
        divorced: 'Divorced/Dissolved',
        widowed: 'Widowed',
        annulled: 'Annulled',
        birthplace: 'Was this person born in the United States of America?',
      },
      para: {
        intro:
          'Provide information about any person from whom you are divorced/dissolved, annulled, or widowed.',
      },
      deceased: {
        label: {
          yes: 'Yes',
          no: 'No',
          dontKnow: "I don't know",
        },
      },
      collection: {
        description: 'Summary of divorcees',
        appendTitle:
          'Do you have any additional person(s) from whom you are divorced/dissolved, annulled, or widowed to report?',
        appendLabel: 'Add another person',
        itemType: 'Person',
      },
      help: {
        birthdate: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        birthplace: {
          title: 'Need help with the birth place?',
          message: 'Provide the place of birth',
          note: '',
        },
        recognized: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        separated: {
          title: 'Need help with separated?',
          message: 'Mark whether you are separated',
          note: '',
        },
        divorced: {
          title: 'Need help with this question?',
          message: 'Mark whether you are currently divorced',
          note: '',
        },
        email: {
          title: 'Need help with providing email?',
          message: 'Enter the email of the person',
          note: '',
        },
        telephone: {
          title: 'Need help with providing a telephone number?',
          message: 'Enter the telephone number of the person',
          note: '',
        },
        address: {
          title: 'Acronyms:',
          message: 'APO - Army Post Office, FPO - Fleet Post Office.',
          note: '',
        },
        dateDivorced: {
          title: 'Estimate the date if unsure',
          message:
            'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
      },
    },
    othernames: {
      heading: {
        name: 'Provide full name',
        maiden: 'Is this their maiden name?',
        used: 'Provide dates name was used',
      },
    },
    help: {
      address: {
        title: 'Acronyms:',
        message: 'APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
      addressSeparated: {
        title: 'Need help with the marital address?',
        message: 'Provide the location of the record if legally separated',
        note: '',
      },
      telephone: {
        title: 'Need help with the telephone number?',
        message: 'Provide the telephone number',
        note: '',
      },
      dateSeparated: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      birthdate: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      birthplace: {
        title: 'Need help with the birth place?',
        message: 'Provide the place of birth',
        note: '',
      },
      foreignBornDocument: {
        title: 'Find the documentation',
        message: 'The document type and number will be on the documentation.',
        note: '',
      },
      othernames: {
        title: 'Need help with other names used?',
        message:
          'Such as maiden name, names by other marriages, civil marriages, legally recognized civil unions, or legally recognized domestic partnerships, nicknames, etc., and provide dates used for each name.',
        note: '',
      },
      separated: {
        title: 'Need help with separated?',
        message: 'Mark whether you are separated',
        note: '',
      },
      divorced: {
        title: 'Need help with this question?',
        message: 'Mark whether you are currently divorced',
        note: '',
      },
      email: {
        title: 'Need help with providing email?',
        message: 'Enter the email of the person',
        note: '',
      },
      hasCohabitant: {
        title: 'Need help with this question?',
        message:
          'Do you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience?',
        note: '',
      },
      citizenship: {
        title: 'List all citizenships this person has',
        message:
          'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
        note: '',
      },
    },
  },
  cohabitant: {
    sectionTitle: {
      title: 'Cohabitants',
    },
    heading: {
      hasCohabitant:
        'Do you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience?',
      name: "Provide your cohabitant's full name",
      address: 'Provide location',
      birthdate: "Provide your cohabitant's birthdate",
      telephone: "Provide your cohabitant's telephone number",
      birthplace: "Provide your cohabitant's the place of birth",
      foreignBornDocument:
        'If the person is foreign born, provide one type of documentation that he or she possesses and the document number',
      ssn: 'Provide your cohabitant’s U.S. Social Security Number',
      othernames: 'Has your cohabitant used another name?',
      appendOthernames: 'Has your cohabitant used any other names?',
      citizenship: "Provide your cohabitant's country(ies) of citizenship. (Select all that apply.)",
      cohabitationBegan: 'Provide date cohabitation residing with person began',
    },
    suggestion: {
      title: "Looks like you've entered this person before",
      paragraph:
        'This name matches a spouse entered under the marital section.\n\nEnter only people who you presently reside with a person, other than a spouse or legally recognized civil union/domestic partner, with whom you share bonds of affection, obligation, or other commitment, as opposed to a person with whom you live for reasons of convenience (e.g. a roommate).',
      dismissLabel: 'This is not my spouse',
      label: 'Spouse match',
      useLabel: 'This is my spouse',
    },
    othernames: {
      heading: {
        name: 'Provide full name',
        maiden: "Is this your cohabitant's maiden name?",
        used: 'Provide dates name was used',
      },
    },
    label: {
      divorced: 'Divorced/Dissolved',
      widowed: 'Widowed',
      annulled: 'Annulled',
      birthplace: 'Was this person born in the United States of America?',
    },
    collection: {
      description: 'Summary of cohabitants',
      appendTitle: 'Do you have an additional cohabitant to report?',
      appendLabel: 'Add another cohabitant',
      itemType: 'Cohabitant',
    },
    help: {
      birthdate: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      birthplace: {
        title: 'Need help with the birth place?',
        message: 'Provide the place of birth',
        note: '',
      },
      recognized: {
        title:
          'Need help with providing date your civil marriage, civil union, or domestic partnership was legally recognized?',
        message:
          'Provide the date your civil marriage, civil union, or domestic partnership was legally recognized',
        note: '',
      },
      separated: {
        title: 'Need help with separated?',
        message: 'Mark whether you are separated',
        note: '',
      },
      divorced: {
        title: 'Need help with this question?',
        message: 'Mark whether you are currently divorced',
        note: '',
      },
      email: {
        title: 'Need help with providing email?',
        message: 'Enter the email of the person',
        note: '',
      },
      telephone: {
        title: 'Need help with providing a telephone number?',
        message: 'Enter the telephone number of the person',
        note: '',
      },
      address: {
        title: 'Need help with providing address?',
        message:
          'Acronyms: APO - Army Post Office, FPO - Fleet Post Office.',
        note: '',
      },
      dateDivorced: {
        title: 'Estimate the date if unsure',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      foreignBornDocument: {
        title: 'Need help with selecting the appropriate documentation?',
        message:
          'If the person is foreign born, provide one type of documentation that he or she possesses and the document number',
        note: '',
      },
      ssn: {
        title: 'Need help with Social Security Number?',
        message: 'Provide the Social Security Number of the person',
        note: '',
      },
      cohabitationBegan: {
        title: 'When did you start living with this person?',
        message:
          'If you are not sure of the exact date give us your best guess and check the "Estimated" checkbox.',
        note: '',
      },
      hasCohabitant: {
        title: 'Cohabitation',
        message:
          'If you live with an individual for reasons of convenience (e.g. a roommate), please select no below. If you share any bonds of affection, obligation, or other commitment with an individual you cohabitate with, please select “yes” below.',
        note: '',
      },
      citizenship: {
        title: 'List all citizenships this person has',
        message:
          'You can provide multiple citizenships in this question.  Selected values will appear below the country selection.',
        note: '',
      },
    },
  },
  people: {
    sectionTitle: {
      title: 'People who know you well',
    },
    label: {
      unit: 'People added',
    },
    summaryProgress: {
      title: 'People who know you well {{years}} year coverage',
      unit: 'Years covered',
      svgAlt: 'People who know you well {{years}} year coverage',
    },
    para: {
      intro:
        '### Provide three people who know you well and who preferably live in the U.S.\n\nThey should be friends, peers, colleagues, college roommates, associates, etc., who are collectively aware of your activities outside of your workplace, school, or neighborhood, and whose combined association with you **covers at least the last {{years}} years.**\n\n **Do not list your spouse, former spouse (s), other relatives, or anyone listed elsewhere on this form.**',
    },
    error: {
      duplicateListItems: {
        title: 'Resolve errors above',
      },
      duplicatePeopleWhoKnowYouError: {
        title: 'Duplicate People Who Know You',
        message: 'There is a name and address which match a person listed in the People Who Know You Well section.  Name and Address cannot match a person listed anywhere else in the security form.  Please update the People Who Know You Well section.'
      },
      duplicatePeopleWhoKnowYouWarning: {
        title: 'Duplicate People Who Know You',
        message: 'There are names which match a person listed in the People Who Know You Well section. Ensure you do not list the same person in the People Who Know You Well section that you have also listed here:'
      },
    },
    person: {
      heading: {
        knownDates: 'Provide dates known',
        name: "Provide this person's full name",
        rank: "Provide this person's rank/title",
        relationship: "Provide this person's  relationship to you",
        mobileTelephone: 'Provide mobile/cell phone number for this person',
        otherTelephone: 'Provide another phone number for this person',
        otherTelephoneSF852013: 'Provide a phone number for this person',
        email: 'Provide email address for this person',
        address: 'Provide home or work address for this person',
      },
      label: {
        address: 'This address is',
        or: 'or',
        idk: "I don't know",
        notApplicable: 'Not applicable',
        relationship: {
          title: 'Check all that apply.',
          neighbor: 'Neighbor',
          friend: 'Friend',
          workAssociate: 'Work Associate',
          schoolmate: 'Schoolmate',
          other: 'Other',
          explanation: 'Provide explanation',
        },
      },
      gap: {
        title: 'Coverage gap',
        para:
          'There is a gap in your {{years}} year period. The entire {{years}} years should be covered with no gaps.',
        button: 'Add another person',
      },
      personsGap: {
        title: 'Coverage gap',
        message: 'List at least 3 people who know you well.',
        note: '',
      },
      help: {
        knownDates: {
          title: 'Tell us the entire time you have known this person',
          message:
            'If you are not sure of the exact dates give us your best guess and check the "Estimated" checkbox.',
          note: '',
        },
        rank: {
          title: 'Need help with the rank/title?',
          message: 'Provide the rank/title of the person who knows you well',
          note: '',
        },
        relationship: {
          title: 'Need help with the relationship?',
          message: 'Provide relationship to you for the person who knows you well',
          note: '',
        },
        mobileTelephone: {
          title: 'Need help with the mobile telephone?',
          message: 'Provide a mobile number for the person who knows you well',
          note: '',
        },
        otherTelephone: {
          title: 'Need help with the other telephone?',
          message: 'Provide another number for the person who knows you well',
          note: '',
        },
        email: {
          title: 'Need help with the email?',
          message: 'Provide the email for the person who knows you well',
          note: '',
        },
        address: {
          title: 'Details:',
          message: 'Military APO/FPO addresses are not permitted.',
          note: '',
        },
      },
      collection: {
        summary: {
          unknown: "Provide the person's information below",
        },
        description: 'Summary of people who know you',
        appendLabel: 'Add another person',
        appendTitle: 'Do you have an additional person who knows you well to list?',
        itemType: 'Person',
      },
    },
  },
};
